<template>
  <div>
    <h2 class="text-h3 mb-3">Source Articles</h2>
    <NewsTab :market="slug" :categories-articles="categoriesArticles" />

    <h2 class="text-h3 mb-3 mt-6">Price Analysis</h2>
    <PriceAnalysisTab
      :name="LITHIUM.name"
      :slug="LITHIUM.slug"
      :service-base-path="LITHIUM.serviceBasePath"
      :icon="LITHIUM.icon"
    />
  </div>
</template>

<script lang="ts" setup>
import { useSeo } from '~/composables/useSeo'
import { LITHIUM } from '~/constants/services/constants'
import NewsTab from '~/components/market-insights/NewsTab.vue'
import PriceAnalysisTab from '~/components/market-insights/PriceAnalysisTab.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  slug: string
  categoriesArticles?: string[]
}>()

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Lithium Market Analysis',
  description:
    'Get the latest news on lithium prices and market trends from Benchmark, covering all the factors that drive price data and market dynamics central to the battery supply chain.',
})
useHead(seo)
</script>
